import React from 'react';

const PersonalInfoForm = ({ data, onChange }) => {
  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <div className="form-section">
      <h2 className="section-title">Personal Information</h2>
      <p className="section-description">
        Start by entering your basic contact information. This will appear at the top of your resume.
      </p>

      <div className="form-group">
        <label className="form-label required">Full Name</label>
        <input
          type="text"
          className="form-input"
          value={data.fullName}
          onChange={(e) => handleChange('fullName', e.target.value)}
          placeholder="John Doe"
        />
      </div>

      <div className="form-row">
        <div className="form-group">
          <label className="form-label required">Email</label>
          <input
            type="email"
            className="form-input"
            value={data.email}
            onChange={(e) => handleChange('email', e.target.value)}
            placeholder="john.doe@email.com"
          />
        </div>

        <div className="form-group">
          <label className="form-label required">Phone</label>
          <input
            type="tel"
            className="form-input"
            value={data.phone}
            onChange={(e) => handleChange('phone', e.target.value)}
            placeholder="+1 (555) 123-4567"
          />
        </div>
      </div>

      <div className="form-group">
        <label className="form-label">Location</label>
        <input
          type="text"
          className="form-input"
          value={data.location}
          onChange={(e) => handleChange('location', e.target.value)}
          placeholder="New York, NY"
        />
        <p className="form-hint">City and state/country</p>
      </div>

      <div className="form-group">
        <label className="form-label">Portfolio/Website (optional)</label>
        <input
          type="url"
          className="form-input"
          value={data.portfolio}
          onChange={(e) => handleChange('portfolio', e.target.value)}
          placeholder="www.zain.com"
        />
      </div>

      <div className="form-group">
        <label className="form-label">LinkedIn Profile (optional)</label>
        <input
          type="url"
          className="form-input"
          value={data.linkedin}
          onChange={(e) => handleChange('linkedin', e.target.value)}
          placeholder="linkedin.com/in/johndoe"
        />
      </div>
    </div>
  );
};

export default PersonalInfoForm;
